import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ReachOurOffices from "./sections/ReachOurOffices";
import SecureInquiry from "./sections/SecureInquiry";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ReachOurOffices />
      <SecureInquiry />
      <Footer />
    </div>;
}